// Core
import { IStateOrProvince } from 'core';

// Store
import { AppState } from 'store';

export const stateAndProvinceSelector = ({ states }: AppState): IStateOrProvince[] => states.statesAndProvinces;
